import { useQueryParam } from '@atlassian/jira-router';
import { ProgressContents } from '../store/progress/types';

function isProgressContentsKey(key: string): key is keyof typeof ProgressContents {
	return key in ProgressContents;
}

function getActiveContent(queryParamValue: string) {
	const activeContentValue = Number(queryParamValue);

	if (Number.isNaN(activeContentValue) && isProgressContentsKey(queryParamValue)) {
		return ProgressContents[queryParamValue];
	}

	return activeContentValue;
}

export const useTransitionHomeQueryParams = () => {
	const [transitionHomeContent, setTransitionHomeContent] = useQueryParam('transitionHomeContent');

	const [transitionHomeActiveTask, setTransitionHomeActiveTask] = useQueryParam(
		'transitionHomeActiveTask',
	);

	const clearQueryParams = () => {
		setTransitionHomeContent(undefined);
		// Workaround: A setTimeout is used to clear the transitionHomeActiveTask query parameter.
		// Without this delay, only the first query parameter gets cleared,
		// even though both setters are called within the same function.
		setTimeout(() => {
			setTransitionHomeActiveTask(undefined);
		});
	};

	const activeTaskIndex = Number(transitionHomeActiveTask);
	const isTaskIndexValid = !Number.isNaN(activeTaskIndex) && activeTaskIndex >= 0;
	const isTransitionHomeContentValid =
		transitionHomeContent && isProgressContentsKey(transitionHomeContent);

	const activeContent = isTransitionHomeContentValid
		? getActiveContent(transitionHomeContent)
		: undefined;

	const queryParamsValid = isTransitionHomeContentValid && isTaskIndexValid;

	return {
		clearQueryParams,
		activeTaskIndex,
		activeContent,
		queryParamsValid,
	};
};
